<template>
  <div class="approval-container">
    <van-nav-bar title="供应商认定申请审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" :taskDefinitionKey="taskDefinitionKey" />
      </van-collapse-item>
      <van-collapse-item name="supplierInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">供应商信息</span>
        </template>
        <supplier-info :supplier-list="supplierList" todo-name="SupplierApplyApproval" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { supplierApplyBase, supplierApplyInfo, saveDevUser } from '@/api/supplierApply'
import Bridge from '@/components/dsbridge'
export default {
  name: 'SupplierApplyApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'supplier-info': () => import('./components/SupplierInfo.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // applyCode: this.$store.getters.businessKey,
      applyCode: this.$route.query.businessKey,
      // taskDefinitionKey: this.$store.getters.taskDefinitionKey,
      taskDefinitionKey: '',
      headInfo: {},
      supplierList: [],
      attachList: [],
      apiSuccess: undefined
    }
  },
  computed: {
    thisPage() {
      return this
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.headInfoFunc()
      this.supplierFunc()
    },
    async headInfoFunc() {
      const headInfoResp = await supplierApplyBase(this.applyCode)
      this.headInfo = headInfoResp.data
      this.attachList = this.headInfo.supplierQuestionnaire
    },
    async supplierFunc() {
      const supplierResp = await supplierApplyInfo(this.applyCode)
      this.supplierList = supplierResp.data
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    async saveDev() {
      await saveDevUser({
        applyCode: this.applyCode,
        devUserId: this.headInfo.devUserId,
        devUserName: this.headInfo.devUserName
      })
    },
    $stopExecute() {
      throw Error()
    },
    onGetProcessInfo(processInfo) {
      this.taskDefinitionKey = processInfo.taskDefKey
    }
  },
  bpmHooks: {
    async beforeExecute(type) {
      if (type === 'agree') {
        if (this.headInfo.identifyApplyType === '01') {
          if (this.taskDefinitionKey === 'Activity_12a1w9w' || this.taskDefinitionKey === 'Activity_0agfue3') {
            if (this.headInfo.devUserId === null || this.headInfo.devUserId === undefined) {
              this.$notify({
                title: '提示',
                message: '请选择研发认定工程师，再进行提交。',
                type: 'warning'
              })
              this.$stopExecute()
            } else {
              this.saveDev()
            }
          }
        } else {
          if (this.headInfo.identifyApplyType !== '00') {
            this.saveDev()
          }
        }
      }
    },
    setProcessVariables(type) {
      if (type === 'agree') {
        if (this.taskDefinitionKey === 'Activity_12a1w9w') {
          // 如果是硬件委员会那么就让硬件委员会选择相应的认定研发人员
          if (this.headInfo.devUserName) {
            return { RD: this.headInfo.devUserId }
          } else {
            this.$notify({
              title: '提示',
              message: '请指定研发认定工程师',
              type: 'warning'
            })
            this.$stopExecute()
            return { opType: type }
          }
        } else if (this.taskDefinitionKey === 'Activity_0agfue3') {
          if (this.headInfo.devUserName) {
            this.devUser = false
            return { RD: this.headInfo.devUserId }
          } else {
            this.$notify({
              title: '提示',
              message: '请指定研发认定工程师',
              type: 'warning'
            })
            this.$stopExecute()
          }
        } else {
          return { opType: type }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
